import type { LucideIcon } from 'lucide-react';
import { SectionHeader } from '@/components/charts/SectionHeader';
import { EmptyState } from '@/components/charts/EmptyState';

interface Props {
  title: string;
  description: string;
  icon: LucideIcon;
  phase: string;
}

export function ModuleStub({ title, description, icon: Icon, phase }: Props) {
  return (
    <div className="space-y-6">
      <SectionHeader title={title} description={description} />
      <EmptyState
        icon={<Icon className="h-8 w-8" />}
        title={`${title} ships in ${phase}`}
        description="Schema, sync function, and module wiring land in the phased build. The layout, period picker, and outlet selector above will drive this view."
      />
    </div>
  );
}
